import type { Translations } from '../../types'

const rolesMessages: Translations = {
  "roles.admin": "Admin",
  "roles.siteManager": "Site Manager",
  "roles.user": "Utente"
}

export default rolesMessages
